export const FETCH_GW = 'FETCH_GW';
export const FETCH_GW_TEMPLATES = 'FETCH_GW_TEMPLATES';
export const FETCH_ONGOING_GW = 'FETCH_ONGOING_GW';
export const FETCH_GW_CHECKLISTS = 'FETCH_GW_CHECKLISTS';
export const SET_GW = 'SET_GW';
export const START_GW = 'START_GW';
export const DELETE_GW = 'DELETE_GW';
export const DELETE_GW_TEMPLATE = 'DELETE_GW_TEMPLATE';
export const DUPLICATE_GW = 'DUPLICATE_GW';
export const CREATE_GW_CHECKLIST = 'CREATE_GW_CHECKLIST';
export const DELETE_GW_CHECKLIST = 'DELETE_GW_CHECKLIST';
export const EDIT_GW_CHECKLIST = 'EDIT_GW_CHECKLIST';
export const DUPLICATE_GW_CHECKLIST = 'DUPLICATE_GW_CHECKLIST';
export const SET_GW_STEP = 'SET_GW_STEP';
export const DELETE_GW_STEP = 'DELETE_GW_STEP';
export const SET_GW_PLANNING = 'SET_GW_PLANNING';
export const DELETE_GW_PLANNING = 'DELETE_GW_PLANNING';
export const SET_GW_CL_ITEM_COMMENT = 'SET_GW_CL_ITEM_COMMENT';
export const DELETE_GW_CL_ITEM_COMMENT = 'DELETE_GW_CL_ITEM_COMMENT';
export const VALIDATE_STEP = 'VALIDATE_STEP';
export const TICK_ITEM = 'TICK_ITEM';


export default {
  FETCH_GW,
  FETCH_GW_TEMPLATES,
  FETCH_ONGOING_GW,
  FETCH_GW_CHECKLISTS,
  SET_GW,
  START_GW,
  DELETE_GW,
  DELETE_GW_TEMPLATE,
  DUPLICATE_GW,
  CREATE_GW_CHECKLIST,
  DELETE_GW_CHECKLIST,
  EDIT_GW_CHECKLIST,
  DUPLICATE_GW_CHECKLIST,
  SET_GW_STEP,
  DELETE_GW_STEP,
  SET_GW_PLANNING,
  DELETE_GW_PLANNING,
  SET_GW_CL_ITEM_COMMENT,
  DELETE_GW_CL_ITEM_COMMENT,
  VALIDATE_STEP,
  TICK_ITEM,
};
